import { IDP_CALLBACK_PATH, SEM_CONTA_PATH } from './config';

/**
 * As rotas que nao servem de destino depois do login.
 *
 * `/login` derruba a sessao ao montar (quem abre a tela de login quer entrar,
 * nao continuar logado), entao voltar para la desfaz o login que acabou de
 * acontecer. O callback e a tela de sem-conta sao passagem, nunca chegada.
 */
const NAO_SAO_DESTINO = [IDP_CALLBACK_PATH, SEM_CONTA_PATH, '/login'];

/**
 * O deep-link guardado quando o fluxo comecou, ou `undefined` quando nao ha um
 * destino util.
 *
 * `undefined` e resposta, nao falha: quem chama decide a rota principal pelo
 * papel do usuario, do mesmo jeito que o login por senha faz. A raiz `/` nao
 * serve de default aqui — no `Router` ela e um `RequireAuth` com lista de
 * permissoes vazia, que sempre reprova e manda de volta para `/login`.
 */
export function destinoPosLogin(returnTo: string | undefined): string | undefined {
  // So caminho interno. `//exemplo.test` e `/\exemplo.test` sao URL absoluta
  // disfarcada de caminho — o navegador sai do app, e o destino pos-login vira
  // um redirect aberto.
  if (returnTo === undefined || !/^\/(?![/\\])/.test(returnTo)) return undefined;

  const caminho = returnTo.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  if (caminho === '/') return undefined;

  return NAO_SAO_DESTINO.includes(caminho) ? undefined : returnTo;
}
